import { sprayIconJson } from './sprayIconJson.js';
import { GenIcon } from 'react-icons';

export const SprayIcon = props => GenIcon(sprayIconJson)(props);
